import { PHASE_STATUS, USER_SESSION_ACTIVITY_KEY, VICE_SESSION_PHASES } from './vice-constants';
import useSessionStore from '@/Stores/useSessionStore';

const sessionStore = useSessionStore();

/**
 * Navigate the user to the appropriate phase based on the cached phase information.
 * This takes care of users who join late and when they refresh their browser
 * @param {*} param0
 */

const isParticipantKickedOutOfConsultation = (
  currentPhaseIdNumber,
  isParticipant,
  userSessionActivityData,
) =>
  currentPhaseIdNumber === VICE_SESSION_PHASES.CONSULTATION &&
  isParticipant &&
  userSessionActivityData?.isKickedOutOfConsultation &&
  userSessionActivityData?.sessionId === sessionStore.sessionId;

const handleLateNavigation = ({ cachedPhaseData, isParticipant }) => {
  if (!cachedPhaseData) return;
  const userSessionActivityData = JSON.parse(
    localStorage.getItem(`${USER_SESSION_ACTIVITY_KEY}_${sessionStore.sessionId}`),
  );
  console.log(cachedPhaseData);

  if (cachedPhaseData.current != 'lobby') {
    const currentPhaseIdNumber = Number(VICE_SESSION_PHASES[cachedPhaseData.current.toUpperCase()]);

    // Prevent user from rejoining Consultation if they were kicked out. Take them to Debrief to wait over there
    if (
      isParticipantKickedOutOfConsultation(
        currentPhaseIdNumber,
        isParticipant,
        userSessionActivityData,
      )
    ) {
      sessionStore.currentPhase = VICE_SESSION_PHASES.DEBRIEF;
      return;
    }

    sessionStore.currentPhase = currentPhaseIdNumber;

    if (cachedPhaseData.status !== PHASE_STATUS.ENDED) {
      if (currentPhaseIdNumber === VICE_SESSION_PHASES.CONSULTATION) {
        sessionStore.isConsultationCallStarted = true;
      } else {
        sessionStore.isGroupCallStarted = true;
      }
      // Check for paused status
      if (cachedPhaseData.status === PHASE_STATUS.PAUSED) {
        sessionStore.togglePausedState(true);
      }
      // Current phase is live
      sessionStore.phases[currentPhaseIdNumber].status = PHASE_STATUS.LIVE;
      // Previous phases have been completed
      for (let i = 1; i < currentPhaseIdNumber; i++) {
        sessionStore.phases[i].status = PHASE_STATUS.COMPLETED;
      }
    } else {
      // Update the Navigation status on the header to reflect completed phases
      for (let i = 1; i < currentPhaseIdNumber + 1; i++) {
        sessionStore.phases[i].status = PHASE_STATUS.COMPLETED;
      }
      sessionStore.currentPhase = currentPhaseIdNumber + 1;
    }
  }
};

export default handleLateNavigation;
